import { shape } from 'prop-types';

import otherFundsModalPropTypes from './otherFundsModalPropTypes';

const otherFundsPropTypes = shape({
  scholarship: otherFundsModalPropTypes,
  sponsorship: otherFundsModalPropTypes,
  loans: otherFundsModalPropTypes,
});

export default otherFundsPropTypes;
